type TranslatableName = Record<string, string> | null | undefined;

function getLocalizedName(name: TranslatableName, locale: string): string {
   if (!name) return '';
   if (name[locale]) return name[locale];

   return Object.values(name).find((value) => !!value) ?? '';
}

export { getLocalizedName };
export type { TranslatableName };
